import { routerSlice } from '@wellesley/router'
import { setRouterPath } from '@wellesley/host-remote/api/actions'
import { useDispatch, useSelector } from 'react-redux'
import { useCurrentFullPath } from '../useCurrentFullPath'

type SetPathProps = {
  transitionPath: string
}

export const useSetPath = () => {
  const dispatch = useDispatch()
  const path = useSelector(routerSlice.selectors.selectPath)
  const currentFullPath = useCurrentFullPath()

  const setPath = ({ transitionPath }: SetPathProps) => {
    if (
      transitionPath &&
      currentFullPath === transitionPath &&
      path !== transitionPath
    ) {
      dispatch(setRouterPath(transitionPath))
    }
  }

  return { setPath }
}
